module.exports = __webpack_public_path__ + "png/quick-registration-puzzle-1.png?9065137b9a444ab6920075b879743c1a";